/* content file: replace all html between <> </> with actual content */
import { FEATURES_MIDDLE_ROW, FEATURES_BOTTOM_ROW } from '../data'
import FeaturesOutput from '../components/FeaturesOutput'

export const TechnikFeatures = () => {
  return (
  <>
    <div className="mb-8">
      <FeaturesOutput DATA={FEATURES_MIDDLE_ROW} toggleMode={true} />
    </div>
    <div className="mb-8">
      <FeaturesOutput DATA={FEATURES_BOTTOM_ROW} />
    </div>
  </>
  )
}
